import { SeeqNames } from 'generated-seeqnames/app.constants.seeqnames';

/**
 * Derives the eventAssetCreator property accessor from an event-property path.
 * Id and Name properties use an empty accessor; other paths drop the final segment after the last dot.
 */
export const getPropertyAccessorForEventAssetCreator = (propertyName?: string): string => {
  if (
    !propertyName ||
    propertyName.toUpperCase() === SeeqNames.Properties.Id ||
    propertyName === SeeqNames.Properties.Name
  ) {
    return '';
  }
  const lastDotIndex = propertyName.lastIndexOf('.');
  return lastDotIndex !== -1 ? propertyName.substring(0, lastDotIndex) : propertyName;
};
